import React from "react";
export default function PreviewEyeIcon() {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0007 4.50391C13.3331 4.50391 16.3877 6.36143 17.9207 9.32025C18.031 9.52289 18.031 9.76761 17.9207 9.97025C16.3877 12.9291 13.3331 14.7866 10.0007 14.7866C6.66833 14.7866 3.61382 12.9291 2.08074 9.97025C1.97048 9.76761 1.97048 9.52289 2.08074 9.32025C3.61382 6.36143 6.66833 4.50391 10.0007 4.50391ZM3.50074 9.65025C4.84238 11.9699 7.32104 13.3961 10.0007 13.3902C12.6799 13.394 15.1576 11.9684 16.5007 9.65025C15.1582 7.3304 12.6811 5.90191 10.0007 5.90191C7.32042 5.90191 4.84328 7.3304 3.50074 9.65025ZM10.0007 6.85025C8.45434 6.85025 7.20074 8.10385 7.20074 9.65025C7.20074 11.1966 8.45434 12.4502 10.0007 12.4502C11.5471 12.4502 12.8007 11.1966 12.8007 9.65025C12.8007 8.90764 12.5057 8.19545 11.9806 7.67035C11.4555 7.14525 10.7433 6.85025 10.0007 6.85025ZM8.60074 9.65025C8.60074 10.4234 9.22754 11.0502 10.0007 11.0502C10.372 11.0502 10.7281 10.9028 10.9907 10.6402C11.2532 10.3776 11.4007 10.0216 11.4007 9.65025C11.4007 8.87705 10.7739 8.25025 10.0007 8.25025C9.22754 8.25025 8.60074 8.87705 8.60074 9.65025Z"
          fill="#12344D"
        />
      </svg>
    </div>
  );
}
